module.exports = __webpack_public_path__ + "ddb9a9bd1cccdc272d6129c2b0641ed9.pdf";